import {Action, Fab} from "react-tiny-fab";
import React, {useState} from "react";
import {ChevronUp, Pencil, Plus} from "lucide-react";
import {useLoggedIn, useStoreProfile} from "../store";
import {themecolors} from "../utils/themecolors";
import Sheet from "./bottom-sheet/sheet";
import SelectPostTypeSheet from "./bottom-sheet/select_post_type";
import {useSheetModal} from "./test/ModalContext";
import SignupPromptSheet from "./bottom-sheet/signup_prompt";

const FabWrapper = ({community}) => {

    const {theme} = useStoreProfile();
    const loggedIn = useLoggedIn();
    const { openModal } = useSheetModal();

    const [selectPostTypeOpen, setSelectPostTypeOpen] = useState();

    const handleCreatePost = () => {

        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);
            return;

        }

        setSelectPostTypeOpen(true);

    };

    const handleScrollToTop = () => {
        document.scrollingElement.scrollTop = 0;
    };

    const bottom = 68;

    return (
        <>
            <Fab
                mainButtonStyles={{backgroundColor: `${theme === 'dark' ? themecolors.dark_background_2 : themecolors.pure_black}`}}
                style={{bottom, right: '8px'}} icon={   <Plus size={24} />} alwaysShowTitle>
                <Action onClick={handleCreatePost} style={{boxShadow: 'none', fill: 'white', backgroundColor: `${theme === 'dark' ? themecolors.dark_background_2 : themecolors.pure_black}`}} text="New Post" ><Pencil size={16} /></Action>
                <Action onClick={handleScrollToTop} style={{boxShadow: 'none', fill: 'white', backgroundColor: `${theme === 'dark' ? themecolors.dark_background_2 : themecolors.pure_black}`}} text="Scroll to Top" ><ChevronUp size={16} /></Action>
            </Fab>
            {selectPostTypeOpen && <Sheet onClose={() => setSelectPostTypeOpen(false) } padding={"menu"}><SelectPostTypeSheet community={community} onClose={() => setSelectPostTypeOpen(false) } /></Sheet>}
        </>
    );
};

export default FabWrapper;
